import styled from 'styled-components';
import colors from '@theme/colors';

export const Td = styled.td`
  vertical-align: top;
  padding: 4px 4px 4px 0;
  min-width: 85px;
  font-size: 12px;
`;

export const Name = styled.div`
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 4px;
  color: ${colors.DARK_GREY};
  display: flex;
  img {
    margin-left: 5px;
  }
`;

export const Details = styled.div`
  color: ${colors.DARK_GREY};
`;



// WEBPACK FOOTER //
// ./components/layout/Attendees.js